import { baseApi } from "./baseApi";

export const subscriptionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    manualSubscriptionSubject: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/subscription/manual",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Subscription", "PurchasablePlans"],
    }),
    changeSubscription: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/subscription",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Subscription", "PurchasablePlans"],
    }),
  }),
});

export const {
  useManualSubscriptionSubjectMutation,
  useChangeSubscriptionMutation,
} = subscriptionApi;
